import "./AboutUs.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheManOfTheHour from "./sections/TheManOfTheHour";
import TheGoldStandardOfPaving from "./sections/TheGoldStandardOfPaving";
import PartnerApartments from "./sections/PartnerApartments";
import SystemFooter from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <MainNavigation />
      <TheManOfTheHour />
      <TheGoldStandardOfPaving />
      <PartnerApartments />
      <SystemFooter />
    </div>;
}